export * from './accounts.service';
export * from './contacts.service';
export * from './dashboard.service';
export * from './leads.service';
export * from './notes.service';
export * from './tasks.service';
export * from './employees.service';
export * from './person.service';
export * from './location.service';
export * from './settings.service';
export * from './masterdata.service';
export * from './enum.service';
export * from './shifts.service';
export * from './declarations.service';
export * from './invoices.service';
export * from './team.service';
export * from './employeeSkills.service';
export * from './templates.service';
export * from './agreements.service';
export * from './nmbrs.service';
export * from './employeeAvailability.service';
export * from './news.service';
export * from './applicants.service';
export * from './applicantStatusHistory.service';
export * from './twinfield.service';
export * from './cootje.service';
export * from './salaryScaleGroup.service';
export * from './hourCode.service';
export * from './twinfieldTest.service';


// WEBPACK FOOTER //
// ./src/app/services/index.ts